import type { ExhibitionCardProps } from "../_model";
import { global } from ":shared/app";
import { ExploreProject } from "./explore-project";
import { ImagesStacked } from "../../SHARED/components";

export function ExhibitionCard(props: ExhibitionCardProps) {
  const handleViewProject = () => {
    global.store.actions.popop.pushModal({
      title: props?.project_name ?? "No project name",
      element: () => <ExploreProject {...props} />,
    });
  };

  return (
    <section class="grid grid-rows-[50%_50%] w-full h-450px rounded-xl bg-bg !overflow-hidden text-16px border-1 border-bg-alt border-solid">
      <div class="flex w-full h-full border-b-1.5 border-solid border-brand-alt">
        <img
          class="w-full h-full object-stretch"
          src={props.project_cover ?? "/images/placeholders/cover.png"}
          alt="alt"
        />
      </div>
      <section class="flex flex-col w-full h-full px-2 py-1">
        <div class="grid grid-cols-[60%_38%] min-w-full w-full min-h-40px max-h-40px !text-0.8em  gap-1.5 items-center">
          <p class="flex w-full h-full truncate items-center">{props.team_name ?? "No Team Name"}</p>
          <p class="flex flex-row w-full h-full  justify-end items-center self-center">
            <span class="flex w-fit h-fit bg-brand-alt text-brand rounded-lg text-center px-2 py-1">
              {props.track ?? "No Track"}
            </span>
          </p>
        </div>
        <p class="flex w-full h-90px text-1.5em font-bold truncate overflow-hidden">
          {props.project_name ?? "No Project Name"}
        </p>
        <p class="flex w-full h-140px text-0.8em overflow-auto scrollbar">{props.ideation ?? "No Ideation"}</p>
        <div class="grid grid-cols-[70%_25%] w-full !h-120px justify-between items-center overflow-hidden gap-2">
          <ImagesStacked items={props.team_members} />
          <button onClick={handleViewProject} class="form-btn no-submit !h-35px ">
            View
          </button>
        </div>
      </section>
    </section>
  );
}
